import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {mainConfig} from "../../config";
import Cookies from 'js-cookie';

import {AppContext} from "../../contexts/app-context";
import {userServices} from "../../services";
import {SWITCH_TO_DIFFERENT_COMPANY_TYPE} from "../../helpers/user_permission.helper";
import SubMenu from "./SubMenu";
import {Dropdown, Icon, Menu} from "antd";
import {LANG_ENUM} from "../../helpers/lang.helper";
import i18n from '../../i18n';

function TopMenu({items, user, setNeedUpdateUser}) {
  const appContext = useContext(AppContext);
  const [currentPath, setCurrentPath] = useState(appContext.currentPath);
  const [isMenuOpen, setMenuStatus] = useState(false);
  const [isDarkTheme, setDarkTheme] = (Cookies.get('theme') === 'dark') ? useState(true) : useState(false);
  const [openDropdownKey, setOpenDropdownKey] = useState(null);

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  },[window.location.pathname])

  const changeTheme = () => {
    if (!isDarkTheme) {
      document.querySelector(".theme").classList.add("theme--dark")
      Cookies.set('theme', 'dark', {expires: 7000})
    } else {
      document.querySelector(".theme").classList.remove("theme--dark")
      Cookies.set('theme', 'light', {expires: 7000})
    }
    setDarkTheme(!isDarkTheme);
  }

  const ItemMenu = ({item}) => {
    const activeClass = item.links && item.links.indexOf(currentPath) !== -1 ? "active" : null;
    
    // Если это выпадающий список
    if (item.isDropdown && item.subItems) {
      // Ищем активный подпункт
      const activeSubItem = item.subItems.find(subItem => 
        subItem.links && subItem.links.indexOf(currentPath) !== -1
      );
      const hasActiveChild = !!activeSubItem;
      
      const dropdownMenu = (
        <Menu className="nav-dropdown-menu">
          {item.subItems.map((subItem, subIndex) => {
            const isSubItemActive = subItem.links && subItem.links.indexOf(currentPath) !== -1;
            return (
              <Menu.Item key={subIndex} className={isSubItemActive ? "ant-dropdown-menu-item-active" : ""}>
                <Link to={subItem.links[0]} onClick={() => {
                  appContext.setCurrentPath(subItem.links[0]);
                  setOpenDropdownKey(null);
                }}>
                  {i18n.t(`main.header.menu.${subItem.langKey}`)}
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      );

      return (
        <li className={`nav-dropdown-item ${hasActiveChild ? 'active' : ''}`}>
          <Dropdown
            overlay={dropdownMenu}
            trigger={["hover"]}
            placement="bottomLeft"
            mouseEnterDelay={0.1}
            mouseLeaveDelay={0.1}
          >
            <span className="nav-dropdown-trigger">
              {i18n.t(`main.header.menu.${item.langKey}`)}
              <Icon type="down" className="nav-dropdown-icon" />
            </span>
          </Dropdown>
        </li>
      );
    }
    
    // Обычный пункт меню
    return (
      <li className={activeClass}>
        <Link to={item.links[0]} onClick={()=>appContext.setCurrentPath(item.links[0])}>{i18n.t(`main.header.menu.${item.langKey}`)}</Link>
      </li>
    );
  };

  // Мобильный пункт меню с выпадающим списком
  const MobileDropdownItem = ({item, itemIndex}) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasActiveChild = item.subItems && item.subItems.some(subItem => 
      subItem.links && subItem.links.indexOf(currentPath) !== -1
    );

    if (!item.isDropdown || !item.subItems) {
      return <ItemMenu key={itemIndex} item={item} />;
    }

    return (
      <li className={`mobile-dropdown-item ${hasActiveChild ? 'active' : ''} ${isOpen ? 'open' : ''}`}>
        <div 
          className="mobile-dropdown-trigger"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{i18n.t(`main.header.menu.${item.langKey}`)}</span>
          <Icon type={isOpen ? "up" : "down"} className="mobile-dropdown-icon" />
        </div>
        {isOpen && (
          <ul className="mobile-dropdown-submenu">
            {item.subItems.map((subItem, subIndex) => (
              <li 
                key={subIndex} 
                className={subItem.links && subItem.links.indexOf(currentPath) !== -1 ? 'active' : ''}
              >
                <Link 
                  to={subItem.links[0]} 
                  onClick={() => {
                    appContext.setCurrentPath(subItem.links[0]);
                    setMenuStatus(false);
                  }}
                >
                  {i18n.t(`main.header.menu.${subItem.langKey}`)}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  };

  const ProfileBlock = ({onLogout}) => {
    const renderSwitchUserType = () => {
      let userInfo = user.info;

      const handleSwitchUserType = () => {
        userServices.switchType()
          .then(() => {
            setNeedUpdateUser(true);
          });
        userInfo.isStaff = !(userInfo.isStaff);
      }

      if (!user.isAccessTo(SWITCH_TO_DIFFERENT_COMPANY_TYPE) || !userInfo.rules.IsCanSwitchType) {
        return null;
      }

      return (
        <div className="head-login-role">
          <div className="form-switch form-switch--role">
            <input value={true} className="form-switch-input" type="radio" name="role" id="switchRoleOwner"
                   checked={userInfo.isStaff} onChange={handleSwitchUserType}/>
            <label className="form-switch-label" htmlFor="switchRoleOwner">
              <span className="only-desktop">{i18n.t(`main.header.role.owner`)}</span>
              <span className="only-mobile">{i18n.t(`main.header.role.ownerShot`)}</span>
            </label>
            <input value={false} className="form-switch-input" type="radio" name="role" id="switchRoleСarrier"
                   checked={!userInfo.isStaff} onChange={handleSwitchUserType}/>
            <label className="form-switch-label" htmlFor="switchRoleСarrier">
              <span className="only-desktop">{i18n.t(`main.header.role.carrier`)}</span>
              <span className="only-mobile">{i18n.t(`main.header.role.carrierShot`)}</span>
            </label>
          </div>
        </div>
      );
    };

    if (!user || user.isGuest()) {
      return (
        <Link to="/login" className="head-login__link-login">
          {i18n.t(`main.header.login`)}
        </Link>
      );
    } else {
      return (
        <React.Fragment>
          <span className="head-login__fio">{user.info.fio}</span>
          {renderSwitchUserType()}
          <Link to="/login" onClick={onLogout} className="btn btn-link head-login__link-logout"/>
        </React.Fragment>
      );
    }
  };

  const langMenu = (
    <Menu>
      {
        Object.keys(LANG_ENUM).map((key) => {
          return (
            <Menu.Item key={key} disabled={appContext.lang.lang === LANG_ENUM[key]} onClick={()=>{appContext.setLang(LANG_ENUM[key])}}>{key}</Menu.Item>
          )
        })
      }
    </Menu>
  )

  return (
    <div className="container">
      <div className="header__block header__block--top">
        <a href="/" className="logo">
          <img src="/img/svg/logo.svg" alt={mainConfig.companyName}/>
        </a>
        <div className="head-nav">
          <ul>
            {items.map((item, index) => <ItemMenu key={index} item={item}/>)}
          </ul>
        </div>
        <div className="head-login">
          <ProfileBlock user={user} onLogout={appContext.logout}/>
        </div>
      </div>
      <div className="header__block header__block--bottom">
        <button className="header__mobile-button" type="button" onClick={() => setMenuStatus(!isMenuOpen)}>
          {!isMenuOpen &&
            <svg width="19" height="13" viewBox="0 0 19 13" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0H19V1H0V0ZM0 6H19V7H0V6ZM19 12H0V13H19V12Z" fill="currentcolor"/>
            </svg>}
          {isMenuOpen &&
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="currentcolor"/>
            </svg>}
        </button>
        <div className="head-nav bottom-menu">
          <SubMenu/>
        </div>
        <div className="header__lang">
          <Dropdown overlay={langMenu} trigger={["click"]} placement="bottomRight">
            <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
              <svg width={"16"} height={"17"} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#EBEBEB" fillRule="evenodd" d="M8 15c.23 0 .843-.226 1.487-1.514.306-.612.563-1.37.742-2.236H5.771c.179.866.436 1.624.742 2.236C7.157 14.774 7.77 15 8 15ZM5.554 9.75a14.399 14.399 0 0 1 0-2.5h4.892c.072.832.072 1.668 0 2.5H5.554Zm6.203 1.5c-.224 1.224-.593 2.308-1.066 3.168a6.53 6.53 0 0 0 3.2-3.168h-2.134Zm2.623-1.5h-2.43a16 16 0 0 0 0-2.5h2.429a6.499 6.499 0 0 1 0 2.5h.001Zm-10.331 0H1.62a6.5 6.5 0 0 1 0-2.5h2.43a16 16 0 0 0 0 2.5h-.001Zm-1.94 1.5h2.134c.224 1.224.593 2.308 1.066 3.168a6.53 6.53 0 0 1-3.2-3.168Zm3.662-5.5h4.458c-.179-.866-.436-1.624-.742-2.236C8.843 2.226 8.23 2 8 2c-.23 0-.843.226-1.487 1.514-.306.612-.563 1.37-.742 2.236Zm5.986 0h2.134a6.53 6.53 0 0 0-3.2-3.168c.473.86.842 1.944 1.066 3.168ZM5.31 2.582c-.473.86-.842 1.944-1.066 3.168H2.109A6.532 6.532 0 0 1 5.31 2.582ZM8 .5a8 8 0 1 1 0 16 8 8 0 0 1 0-16Z" clipRule="evenodd"/>
              </svg>
              {appContext.lang.lang} <Icon type="down" />
            </a>
          </Dropdown>
        </div>
        <div className="form-switch form-switch--theme">
          <label className={`form-switch-label${isDarkTheme? ' is-active' : ''}`} htmlFor="themeDark" aria-label="Темная тема">
            <input className="form-switch-input" type="radio" name="theme" value="0" id="themeDark"
                   defaultChecked={isDarkTheme} onClick={changeTheme}/>
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.93005 0.119995C4.86062 0.119995 0.75 4.23059 0.75 9.29999C0.75 14.3694 4.86062 18.48 9.93005 18.48C14.9995 18.48 19.1101 14.3694 19.1101 9.29999C19.1101 8.83079 19.0693 8.36159 19.0081 7.91279C18.0085 9.31019 16.3765 10.218 14.5201 10.218C11.4805 10.218 9.01205 7.74959 9.01205 4.70999C9.01205 2.86379 9.91985 1.22159 11.3173 0.221995C10.8685 0.160795 10.3993 0.119995 9.93005 0.119995Z"
                fill="currentcolor"/>
            </svg>
          </label>
          <label className={`form-switch-label${!isDarkTheme? ' is-active' : ''}`} htmlFor="themeLight" aria-label="Светлая тема">
            <input className="form-switch-input" type="radio" name="theme" value="1" id="themeLight"
                   defaultChecked={!isDarkTheme} onClick={changeTheme}/>
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11 6.16962C8.24 6.16962 6 8.40962 6 11.1696C6 13.9296 8.24 16.1696 11 16.1696C13.76 16.1696 16 13.9296 16 11.1696C16 8.40962 13.76 6.16962 11 6.16962ZM1 12.1696H3C3.55 12.1696 4 11.7196 4 11.1696C4 10.6196 3.55 10.1696 3 10.1696H1C0.45 10.1696 0 10.6196 0 11.1696C0 11.7196 0.45 12.1696 1 12.1696ZM19 12.1696H21C21.55 12.1696 22 11.7196 22 11.1696C22 10.6196 21.55 10.1696 21 10.1696H19C18.45 10.1696 18 10.6196 18 11.1696C18 11.7196 18.45 12.1696 19 12.1696ZM10 1.16962V3.16962C10 3.71962 10.45 4.16962 11 4.16962C11.55 4.16962 12 3.71962 12 3.16962V1.16962C12 0.619617 11.55 0.169617 11 0.169617C10.45 0.169617 10 0.619617 10 1.16962ZM10 19.1696V21.1696C10 21.7196 10.45 22.1696 11 22.1696C11.55 22.1696 12 21.7196 12 21.1696V19.1696C12 18.6196 11.55 18.1696 11 18.1696C10.45 18.1696 10 18.6196 10 19.1696ZM4.99 3.74962C4.6 3.35962 3.96 3.35962 3.58 3.74962C3.19 4.13962 3.19 4.77962 3.58 5.15962L4.64 6.21962C5.03 6.60962 5.67 6.60962 6.05 6.21962C6.43 5.82962 6.44 5.18962 6.05 4.80962L4.99 3.74962ZM17.36 16.1196C16.97 15.7296 16.33 15.7296 15.95 16.1196C15.56 16.5096 15.56 17.1496 15.95 17.5296L17.01 18.5896C17.4 18.9796 18.04 18.9796 18.42 18.5896C18.81 18.1996 18.81 17.5596 18.42 17.1796L17.36 16.1196ZM18.42 5.15962C18.81 4.76962 18.81 4.12962 18.42 3.74962C18.03 3.35962 17.39 3.35962 17.01 3.74962L15.95 4.80962C15.56 5.19962 15.56 5.83962 15.95 6.21962C16.34 6.59962 16.98 6.60962 17.36 6.21962L18.42 5.15962ZM6.05 17.5296C6.44 17.1396 6.44 16.4996 6.05 16.1196C5.66 15.7296 5.02 15.7296 4.64 16.1196L3.58 17.1796C3.19 17.5696 3.19 18.2096 3.58 18.5896C3.97 18.9696 4.61 18.9796 4.99 18.5896L6.05 17.5296Z"
                fill="currentcolor"/>
            </svg>
          </label>
        </div>
      </div>
      {isMenuOpen &&
        <div className="header__block header__block--mobile">
          <div className="header__mobile-menu container">
            <div className="head-nav">
              <ul>
                {items.map((item, index) => (
                  <MobileDropdownItem key={index} item={item} itemIndex={index} />
                ))}
              </ul>
              <SubMenu/>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default TopMenu;